const UPDATE_PARTNER_SITE = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_PARTNER_SITE'
const UPDATE_SEGMENT = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_SEGMENT'
const UPDATE_LINE = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_LINE'
const UPDATE_PARTNER_NAME = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_PARTNER_NAME'
const UPDATE_ODM = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_ODM'
const UPDATE_CUSTOMER_CLASS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_CUSTOMER_CLASS'
const UPDATE_PARTNER_SITE_LIST = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_PARTNER_SITE_LIST'
const FETCH_PARTNER_SITES = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_PARTNER_SITES'
const FETCH_PARTNER_SITES_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_PARTNER_SITES_START'
const FETCH_PARTNER_SITES_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_PARTNER_SITES_SUCCESS'
const FETCH_PARTNER_SITES_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_PARTNER_SITES_ERROR'
const POST_PARTNER_SITE = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/POST_PARTNER_SITE'
const POST_PARTNER_SITE_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/POST_PARTNER_SITE_START'
const POST_PARTNER_SITE_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/POST_PARTNER_SITE_SUCCESS'
const POST_PARTNER_SITE_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/POST_PARTNER_SITE_ERROR'
const UPDATE_SEGMENT_LIST = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_SEGMENT_LIST'
const UPDATE_LINE_LIST = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_LINE_LIST'
const FETCH_SEGMENT_LINE = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_SEGMENT_LINE'
const FETCH_SEGMENT_LINE_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_SEGMENT_LINE_START'
const FETCH_SEGMENT_LINE_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_SEGMENT_LINE_SUCCESS'
const FETCH_SEGMENT_LINE_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_SEGMENT_LINE_ERROR'
const UPDATE_AE_REGION = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_AE_REGION'
const FETCH_AE_REGION_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_START'
const FETCH_AE_REGION_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_SUCCESS'
const FETCH_AE_REGION_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_ERROR'
const UPDATE_AE_REGION_LIST = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/UPDATE_AE_REGION_LIST'
const FETCH_AE_REGION_LIST = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_LIST'
const FETCH_AE_REGION_LIST_START = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_LIST_START'
const FETCH_AE_REGION_LIST_SUCCESS = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_LIST_SUCCESS'
const FETCH_AE_REGION_LIST_ERROR = 'fulcrum/container/Admin/PartnerSite/PartnerSiteAddDialog/FETCH_AE_REGION_LIST_ERROR'

export {
  UPDATE_PARTNER_SITE,
  UPDATE_SEGMENT,
  UPDATE_LINE,
  UPDATE_PARTNER_NAME,
  UPDATE_ODM,
  UPDATE_CUSTOMER_CLASS,
  UPDATE_PARTNER_SITE_LIST,
  FETCH_PARTNER_SITES,
  FETCH_PARTNER_SITES_START,
  FETCH_PARTNER_SITES_SUCCESS,
  FETCH_PARTNER_SITES_ERROR,
  POST_PARTNER_SITE,
  POST_PARTNER_SITE_START,
  POST_PARTNER_SITE_SUCCESS,
  POST_PARTNER_SITE_ERROR,
  UPDATE_SEGMENT_LIST,
  UPDATE_LINE_LIST,
  FETCH_SEGMENT_LINE,
  FETCH_SEGMENT_LINE_START,
  FETCH_SEGMENT_LINE_SUCCESS,
  FETCH_SEGMENT_LINE_ERROR,
  UPDATE_AE_REGION,
  UPDATE_AE_REGION_LIST,
  FETCH_AE_REGION_START,
  FETCH_AE_REGION_SUCCESS,
  FETCH_AE_REGION_ERROR,
  FETCH_AE_REGION_LIST,
  FETCH_AE_REGION_LIST_START,
  FETCH_AE_REGION_LIST_SUCCESS,
  FETCH_AE_REGION_LIST_ERROR,
}
